import React, { ReactNode } from 'react';
import classNames from 'classnames';
import Spinner, { SpinnerType } from 'legacy/common/components/spinner/Spinner';

interface ButtonProps {
  variant:
    | 'primary'
    | 'primaryDark'
    | 'secondary'
    | 'inverted'
    | 'invertedDark'
    | 'danger';
  size?: 'small' | 'regular' | 'large' | 'xlarge';
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  onClick?: (...args: any[]) => void; // Accept any number of arguments of any type
  isIconButton?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit' | 'reset';
}
const Button = ({
  variant,
  children,
  onClick,
  className,
  loading,
  disabled,
  size = 'regular',
  isIconButton = false,
  type = 'button'
}: ButtonProps) => {
  const baseClasses = 'mt-3 flex justify-center items-center rounded-full';
  const iconButtonClasses =
    'h-11 w-11 flex justify-center items-center rounded-full';
  const variantStyles = {
    primary: 'bg-[#6585FF] text-white',
    primaryDark: 'bg-[#3853C4] text-white',
    secondary: 'bg-[#EFF2FF] text-[#3853C4]',
    inverted: 'text-[#ab0a0a] font-bold',
    invertedDark:
      'text-[#3853C4] font-bold border border-neutral-200 rounded-xl bg-white',
    danger: 'bg-[#ab0a0a] text-white'
  };
  const sizeStyles = {
    small: 'h-8 px-3',
    regular: 'h-11 px-4',
    large: 'h-[44px] px-6 text-base font-semibold',
    xlarge: 'h-[49px] px-8 text-lg leading-tight font-semibold'
  };

  const btnTypeClasses = isIconButton ? iconButtonClasses : baseClasses;

  const variantClasses = variantStyles[variant];
  const sizeClasses = sizeStyles[size];

  return (
    <button
      className={classNames(
        btnTypeClasses,
        variantClasses,
        sizeClasses,
        className,
        {
          'cursor-not-allowed': disabled || loading,
          'opacity-70 bg-neutral-300': disabled
        }
      )}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type -- we need to be able to pass in a type and eslint doesn't like that we have 3 possible values
      type={type}
      disabled={disabled || loading}
    >
      {loading ? <Spinner type={SpinnerType.DEFAULT} /> : children}
    </button>
  );
};

export default Button;
